import { render } from "./RecaptchaV3.vue?vue&type=template&id=ff1e2506"
import script from "./RecaptchaV3.vue?vue&type=script&lang=js"
export * from "./RecaptchaV3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__